import { NestedOption } from '~/core/shared/types/utility';
import { notNullOrUndefined } from '~/core/shared/utils/general';
import { getOptionsAt } from './getOptionsAt';

/**
 * One options array per select: select n offers the options below the first n segments.
 *
 * The extra entry past the last segment is the next level to reveal when that choice opens
 * further options. Once a prefix finds nothing, every longer one finds nothing too, so
 * dropping the nulls keeps exactly the selects that belong.
 */
export const getNestedSelectOptions = (
  options: readonly NestedOption[],
  segments: readonly string[],
): Array<readonly NestedOption[]> =>
  [...segments, null]
    .map((_, index) => getOptionsAt(options, segments.slice(0, index)))
    .filter(notNullOrUndefined);
